import React from 'react';

const OjibweLogo = (props) => {
  return (
    <svg id="Layer_1" x="0px" y="0px" viewBox="0 0 100 100" xmlSpace="preserve" {...props}>
      <style>
        {'.st6{fill:none;stroke:#fff;stroke-width:4;stroke-miterlimit:3.8637}.st7{fill:#00539f}.st8{fill:#ed174c}'}
      </style>
      <path
        d="M3.3 49.9c0-26 20.5-47.2 45.9-47.2S95 23.9 95 49.9c0 26-20.5 47.2-45.9 47.2S3.3 76 3.3 49.9h0z"
        fill="#fff"
        stroke="#00539f"
        strokeWidth={1.8382}
        strokeMiterlimit={3.8637}
      />
      <path
        d="M16.4 50.6C16.4 32 31 16.9 49.1 16.9c18 0 32.7 15.1 32.7 33.7S67.2 84.3 49.1 84.3c-18 0-32.7-15.1-32.7-33.7h0z"
        fill="#00539f"
        stroke="#00539f"
        strokeWidth={0.9189}
        strokeMiterlimit={3.8637}
      />
      <path
        d="M66.8 35.5l-3.9-.7s-3.1-.6-4.4-.2c-1.3.5-2.9-.5-3.4-.6-.5-.2-2.7-1.4-4-1.4-1.3 0-1.5-.6-3.3.1-1.8.6-1.7.2-2.4-.2s-2.1-1-2.7-5.7c0 0-.2-2.5-3-2.5v5.8s-.5.5-1.5.2h-6.1v8.3s1.3 6.7 1.2 8.5c-.1 1.7-.3 2.9-.3 2.9s-1.8 2.2.2 3.7 1.3 3.7 1.3 4.2-1.1 6.5.4 10.2h27.5s.2-2.6-1.9-5.4L55 57.4l-.9-4.7.2-5.4 1.8-3s2.6-4.1 5-5.1 4.7-2.3 4.7-2.3l1-1.4h0z"
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.9191}
        strokeMiterlimit={3.8637}
      />
      <defs>
        <path
          id="SVGID_1_"
          d="M37.4 49.3c0-5.4 4.4-9.8 9.7-9.8 5.4 0 9.7 4.4 9.7 9.8s-4.4 9.8-9.7 9.8c-5.4 0-9.7-4.4-9.7-9.8z"
        />
      </defs>
      <use xlinkHref="#SVGID_1_" overflow="visible" fill="#00539f" />
      <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_1_" overflow="visible" />
      </clipPath>
      <path
        d="M66.7 35.4l-3.9-.7s-3.1-.6-4.4-.2c-1.3.5-2.9-.5-3.4-.6-.5-.2-2.7-1.4-4-1.4-1.3 0-1.5-.6-3.3.1-1.8.6-1.7.2-2.4-.2s-2.1-1-2.7-5.7c0 0-.2-2.5-3-2.5V30s-.5.5-1.5.2H32v8.3s1.3 6.7 1.2 8.5c-.1 1.8-.3 2.9-.3 2.9S31 52 33 53.6c2 1.5 1.3 3.7 1.3 4.2s-1.1 6.5.4 10.2h27.5s.2-2.6-1.9-5.4l-5.4-5.1-.9-4.9.2-5.4 1.8-3s2.6-4.1 5-5.1 4.7-2.3 4.7-2.3l1-1.4h0z"
        clipPath="url(#SVGID_2_)"
        fill="#00539f"
        stroke="#fff"
        strokeWidth={0.7374}
        strokeMiterlimit={3.8637}
      />
      <path
        d="M73.6 48.5l-1.3-4.8h3.3l-1.1 4.8s3.5.5 4.7 1.6c0 0-1.5 1.2-8.8 1.1l-2.4-.3v-2.1c.1 0 2.7-.8 5.6-.3h0z"
        fill="#ed174c"
        stroke="#ed174c"
        strokeWidth={1.8382}
        strokeMiterlimit={3.8637}
      />
      <path
        d="M19.8 49.6l13.3-1.3s1.4-.3 2 .5h33v2.1H35.2s-1.3.6-2.1.3l-13.3-1.6h0z"
        fill="#aab5da"
        stroke="#aab5da"
        strokeWidth={1.9851}
        strokeMiterlimit={3.8637}
      />
      <path className="st6" d="M67.9 48.5L67.9 51.1" />
      <path
        className="st7"
        d="M13.5 39.4l-.3 1.1-4.9-1.2 4.6 2.3-.3 1.2-5.1-.2 4.9 1.2-.3 1.1-5.8-1.5.4-1.8 4.9.1-4.3-2.2.4-1.5 5.8 1.4zM15 35.4l-.4 1.2-5.7-2.1.4-1.2 5.7 2.1zM16.2 30.8l1.6-2.5.9.6-2.3 3.6-5-3.3.7-1.1 4.1 2.7zM20.5 24.9l2-2.2.8.7-2.8 3.2-4.5-4 .8-.9 3.7 3.2zM26.1 14.9l-2.6 1.9.8 1 2.3-1.8.6.9-2.2 1.8.9 1.2 2.7-2 .6.9-3.7 2.8-3.5-4.9 3.5-2.7.6.9zM36.7 14.2l2.8-1 .4 1-4 1.4-2-5.7 1.2-.4 1.6 4.7zM43.8 13.6l-1.3.1 1.8-6.1 1.4-.1 2.4 5.9-1.4.1-.4-1.2-2.2.1-.3 1.2zm.6-2.3l1.5-.1-.9-2.3-.6 2.4zM55.2 9.8c0-.4-.1-1.1-1.2-1.2-.6-.1-1.5.2-1.8 1.8-.2 1.1.1 2.1 1.2 2.3.7.1 1.2-.2 1.5-.9l1.2.2c-.5 1.3-1.4 2-2.9 1.8-1.6-.3-2.5-1.5-2.2-3.6.3-2.1 1.7-2.9 3.2-2.7 1.8.3 2.3 1.6 2.2 2.5l-1.2-.2zM60.2 13.2c-.1.3-.2 1 .9 1.4.6.2 1.2.3 1.4-.3.2-.4-.2-.7-.8-1.1l-.6-.4c-.8-.5-1.6-1.1-1.2-2.3.2-.6 1-1.6 2.8-.9 1.7.6 1.8 1.9 1.5 2.6l-1.1-.4c.1-.3.2-.9-.8-1.3-.4-.2-1-.2-1.2.3-.2.4.2.7.4.8l1.3.8c.7.5 1.3 1 .9 2.1-.6 1.7-2.4 1.2-2.9 1-2.1-.8-2-2.1-1.7-2.8l1.1.5zM73.1 14.9l2.3 1.8c1.2.9.9 1.9.6 2.3-.5.7-1.1.6-1.3.5.4.7.2 1.2-.1 1.7-.3.4-.7.6-1.2.7-.5.1-.9 0-1.8-.7l-2-1.5 3.5-4.8zM71 19.6l1.2.9c.5.4.9.4 1.3-.1.3-.4.1-.9-.3-1.1l-1.3-1-.9 1.3zm1.6-2.1l1.2.9c.4.3.8.4 1.1 0 .3-.4.1-.7-.3-1.1l-1.2-.9-.8 1.1zM76 25.4l-.9-1L81 22l1 1.1-3.1 5.6-.9-1 .7-1.1-1.5-1.7-1.2.5zm2.2-.9l1 1.1 1.3-2.1-2.3 1zM87.5 31.9L88 33l-5.4 2.6-.6-1.1 2.8-4.1-3.8 1.9-.5-1.1 5.4-2.6.6 1.2-2.7 4 3.7-1.9zM89.8 37.4l.6 2.6c.5 2-1.1 2.8-2.2 3-1.3.3-3.2.2-3.6-1.7l-.6-2.5 5.8-1.4zm-4.6 2.3l.3 1.2c.2 1 1.3 1.1 2.3.9 1.7-.4 1.7-1.3 1.6-1.8l-.4-1.2-3.8.9zM22.3 74.2c.5.6 1.6 2.5-.6 4.2-2.2 1.8-3.8.4-4.3-.3-.5-.6-1.6-2.5.6-4.2 2.2-1.8 3.8-.3 4.3.3zm-4.1 3.3c.4.5 1.4 1 2.7-.1 1.3-1.1 1-2.1.6-2.6s-1.4-1-2.7.1c-1.4 1.1-1.1 2.1-.6 2.6zM23.9 84.2l-1-.7 3.4-5 3.6 2.4-.6.9-2.5-1.7-.8 1.1 2.2 1.5-.6.9-2.2-1.5-1.5 2.1zM38.3 84.7c.8.2 2.7 1.2 1.8 3.9-.8 2.7-2.9 2.4-3.7 2.2-.8-.2-2.7-1.2-1.8-3.9.9-2.7 3-2.4 3.7-2.2zm-1.5 5.1c.6.2 1.7.1 2.2-1.5.5-1.6-.3-2.3-.9-2.5-.6-.2-1.7-.1-2.2 1.5-.6 1.6.2 2.3.9 2.5zM46.8 90.8c-.1 1.3-.9 1.8-2.1 1.7-2-.2-1.9-1.5-1.7-2.6l1.2.1c-.1.9-.1 1.4.6 1.5.7.1.7-.3.8-.8l.4-4.3 1.3.1-.5 4.3zM51.9 92.5l-1.3.1-.4-6 1.3-.1.4 6zM54.5 86.2l2.9-.6c1.4-.3 2 .6 2.1 1.2.2.8-.3 1.2-.5 1.4.8.1 1.1.7 1.2 1.3.1.5 0 1-.3 1.3-.3.4-.6.7-1.8.9l-2.5.5-1.1-6zm1.6 2.1l1.4-.3c.5-.1.8-.4.7-.8-.1-.5-.5-.6-1-.5l-1.3.3.2 1.3zm.5 2.5l1.5-.3c.6-.1.9-.4.8-1-.1-.5-.6-.6-1-.5l-1.6.3.3 1.5zM61.8 84.5l1.2-.6c2.2 2.5 2.5 2.9 2.9 3.4-.2-.6-.4-1.2-1.3-4.3l1.2-.6c2.2 2.6 2.4 2.8 2.9 3.5-.2-.6-.3-1.1-1.2-4.3l1.1-.6 1.3 6.1-1.1.6c-1.9-2.3-2.3-2.8-3-3.7.4 1.1.5 1.5 1.4 4.6l-1 .6-4.4-4.7zM74.8 77.3l-2.5 2 .8 1 2.3-1.8.7.8-2.3 1.8 1 1.2 2.6-2.1.6.8-3.6 2.9-3.8-4.7 3.4-2.8.8.9z"
      />
      <path className="st8" d="M41.5 48.4c0-1.5 2.4-2.6 5.3-2.6s5.3 1.2 5.3 2.6H41.5z" />
      <path className="st8" d="M45.9 45.6L47.6 45.6 46.8 40.3 45.9 45.6z" />
      <path className="st8" d="M42.7 46.5L44.1 45.9 39.8 42.8 42.7 46.5z" />
      <path className="st8" d="M50.9 46.5L49.5 46 53.8 42.8 50.9 46.5z" />
      <path className="st6" d="M35.6 48.4L35.6 51.5" />
      <path
        d="M53.6 51.3l-.6.2c-1 .4-1.7.4-3.1.4-.7 0-1.3 0-1.9-.1.4.3.8.7 1.3 1.1 1 1 1.8 2.2 2.2 3.2h-.1c-1-.4-2-1.1-3.1-2.2-.4-.4-.7-.7-1-1.1v-.1c.1.5.1 1.1.1 1.7 0 1.5-.3 2.8-.7 3.8-.4-1-.7-2.3-.7-3.7 0-.7.1-1.3.2-1.9-.3.4-.7.9-1.1 1.3-1.1 1.1-2.2 1.8-3.2 2.2.4-1 1.1-2.1 2.2-3.1.4-.4.8-.8 1.3-1.1-.6.1-1.2.1-1.8.1-1.5 0-2.8-.3-3.8-.7h13.8z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#ed174c"
      />
      <path
        d="M53.6 51.3l-.6.2c-1 .4-1.7.4-3.1.4-.7 0-1.3 0-1.9-.1.4.3.8.7 1.3 1.1 1 1 1.8 2.2 2.2 3.2h-.1c-1-.4-2-1.1-3.1-2.2-.4-.4-.7-.7-1-1.1v-.1c.1.5.1 1.1.1 1.7 0 1.5-.3 2.8-.7 3.8-.4-1-.7-2.3-.7-3.7 0-.7.1-1.3.2-1.9h0s0 0 0 0c-.3.4-.7.9-1.1 1.3-1.1 1.1-2.2 1.8-3.2 2.2.4-1 1.1-2.1 2.2-3.1.4-.4.8-.8 1.3-1.1h0c-.6.1-1.2.1-1.8.1-1.5 0-2.8-.3-3.8-.7h13.8z"
        fill="none"
        stroke="#ed174c"
        strokeWidth={0.1277}
        strokeMiterlimit={3.8637}
      />
    </svg>
  );
};

export default OjibweLogo;
